/**
 * Marks the "Create a new workout" tutorial step (step 3) as completed.
 * This should be called when:
 * - Adding the first exercise to a workout
 * - Adding a workout from the library
 *
 * @param {Object} coach - The coach object (must have onboardingShowBlock property)
 * @param {Function} showToast - Toast function to show completion message
 * @returns {boolean} - Returns true if the step was marked as completed, false otherwise
 */
export const markTutorialStepCompleted = (coach, showToast) => {
  if (!coach || !coach.onboardingShowBlock) {
    return false;
  }

  coach.setProperty("onboardingShowBlock", false);
  coach.updateCoachPublicProfile({
    onboarding_show_block: false,
  });

  showToast("step2Completed-string", {
    type: "info",
    description: "step2CompletedDescription-string",
  });

  return true;
};
